import address from 'plugins/i18n/entity/address.en.ts'
import unit from 'plugins/i18n/entity/unit.en.ts'

const building = {
	name: 'Building | Buildings',
	icon: 'fa-regular fa-building | fa-regular fa-buildings',
	fields: {
		hp_id: 'ID',
		address: {
			...address.fields,
		},
		building_type: {
			name: 'Type',
		},
		document_container: {
			units: {
				...unit.fields,
			},
		},
		heating_type: 'Heating',
		hotwater_type: 'Hot water',
		garage_type: 'Garage',
		trashbarrel_type: 'Trash bins',
		team: 'Team',
		year_of_construction: 'Year of Construction',
		propertymanager_id: 'Property Manager',
		propertymanager: {
			person: {
				lastname: 'Property Manager',
			},
		},
		proposed_for_export: 'Aaremo Release',
	},
	tabs: {
		building: '@:common.information',
		documents: '@:entity.document.name',
		units: '@:entity.unit.name',
		persons: '@:entity.person.name',
		tasks: '@:entity.task.name',
		meters: '@:entity.meter.name',
		cis: '@:entity.cis.name',
		craftsman_tasks: '@:entity.craftsman_task.name',
		handoverprotocols: '@:entity.handoverProtocol.name',
		accounting: 'Accounting',
	},
}

export default building
